// extracted by mini-css-extract-plugin
var _1 = "default___IkOqd";
var _2 = "#68914d";
var _3 = "#9cc681";
var _4 = "#8ab46f";
var _5 = "body-main___Z_Ky8";
var _6 = "body-medium___Afx3x";
var _7 = "body-plus___vB_Cl";
var _8 = "body-small___vOxTu";
var _9 = "body-xsmall___zR7V2";
var _a = "8px";
var _b = "6px";
var _c = "8px";
var _d = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _e = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _f = "10px";
var _10 = "#e8e8e8";
var _11 = "16px 24px";
var _12 = "#38aa73";
var _13 = "#956c22";
var _14 = "#2988bd";
var _15 = "#eee";
var _16 = "#c4842d";
var _17 = "#b8567c";
var _18 = "#8b6e4e";
var _19 = "#5889c2";
var _1a = "#4e8a8a";
var _1b = "#6a8a3e";
var _1c = "#7b5ea7";
var _1d = "#4a6fa5";
var _1e = "#3a8a6e";
var _1f = "#c25b4e";
var _20 = "#fafbfc";
var _21 = "#1e3050";
var _22 = "#293d62";
var _23 = "#fafbfc";
var _24 = "rgba(0,0,0,.12)";
var _25 = "#d9d9d9";
var _26 = "rgba(5,5,5,.1)";
var _27 = "#eaf2fc";
var _28 = "rgba(0,0,0,.65)";
var _29 = "#ebebeb";
var _2a = "#068467";
var _2b = "rgba(6,132,103,.1)";
var _2c = "#dc4949";
var _2d = "rgba(220,73,73,.1)";
var _2e = "#787c81";
var _2f = "#d6d9dc";
var _30 = "#f3f5f7";
var _31 = "#73c9b2";
var _32 = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _33 = "#b8e7da";
var _34 = "#5357f8";
var _35 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _36 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _37 = "#f7f8f9";
var _38 = "#edeeef";
var _39 = "#7b8996";
var _3a = "#ededed";
var _3b = "#f4f5f7";
var _3c = "#fbfbfc";
var _3d = "rgba(0,0,0,.75)";
var _3e = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3f = "rgba(0,0,0,.3)";
var _40 = "rgba(0,0,0,.5)";
var _41 = "rgba(0,0,0,.4)";
var _42 = "rgba(0,0,0,.95)";
var _43 = "rgba(0,0,0,.65)";
var _44 = "rgba(0,0,0,.85)";
var _45 = "20px";
var _46 = "#f41e28";
var _47 = "1063px";
var _48 = "rgba(227,89,86,.2)";
var _49 = "#e35956";
var _4a = "16px 24px";
var _4b = "28px";
var _4c = "32px";
var _4d = "18px";
var _4e = "14px";
var _4f = "14px";
var _50 = "15px";
var _51 = "12.6px";
var _52 = "11px";
var _53 = "20px";
var _54 = "28px";
var _55 = "700";
var _56 = "200";
var _57 = "300";
var _58 = "500";
var _59 = "400";
var _5a = "600";
var _5b = "hsla(0,0%,100%,.2)";
var _5c = "#ccc";
var _5d = "49px";
var _5e = "heading-1___ylH8o";
var _5f = "heading-2___TGImX";
var _60 = "heading-3___nHMHC";
var _61 = "heading-4___bcxlH";
var _62 = "heading-5___cA7pI";
var _63 = "5px";
var _64 = "#5357f8";
var _65 = "rgba(0,0,0,.4)";
var _66 = "page-heading___RD8zW";
var _67 = "#fafafa";
var _68 = "hsla(0,0%,100%,.9)";
var _69 = "15px";
var _6a = "20px";
var _6b = "24px";
var _6c = "hsla(0,0%,100%,.6)";
var _6d = "#7e7eff";
var _6e = "hsla(0,0%,100%,.7)";
var _6f = "hsla(0,0%,100%,.3)";
var _70 = "hsla(0,0%,100%,.575)";
var _71 = "60px";
var _72 = "208px";
var _73 = "rgba(82,196,26,.2)";
var _74 = "#52c41a";
var _75 = "12px";
var _76 = "20px";
var _77 = "rgba(250,173,20,.2)";
var _78 = "#faad14";
var _79 = "#fff";
var _7a = "hsla(0,0%,100%,.2)";
export { _1 as "_default", _2 as "actionButtonColorDark", _3 as "actionButtonColorLight", _4 as "actionButtonColorMedium", _5 as "body-main", _6 as "body-medium", _7 as "body-plus", _8 as "body-small", _9 as "body-xsmall", _a as "borderRadiusCard", _b as "borderRadiusMain", _c as "borderRadiusSurface", _d as "boxShadowInnerXs", _e as "boxShadowXl", _f as "btnRightMargin", _10 as "cardBorderColor", _11 as "cardPadding", _12 as "changeSetCompletedColor", _13 as "changeSetManuallyChangesProposed", _14 as "changeSetScheduledChangesProposed", _15 as "chipBackground", _16 as "colorAccentAmber", _17 as "colorAccentBerry", _18 as "colorAccentBrown", _19 as "colorAccentCornflower", _1a as "colorAccentCyan", _1b as "colorAccentOlive", _1c as "colorAccentPurple", _1d as "colorAccentSteelBlue", _1e as "colorAccentTeal", _1f as "colorAccentTerracotta", _20 as "colorBackgroundMain", _21 as "colorBackgroundSidebar", _22 as "colorBackgroundSidebarHover", _23 as "colorBackgroundTabs", _24 as "colorBorderContainer", _25 as "colorBorderMain", _26 as "colorBorderSecondary", _27 as "colorDeltaCyanBlueBg", _28 as "colorDeltaGray", _29 as "colorDeltaGrayBg", _2a as "colorDeltaGreen", _2b as "colorDeltaGreenBg", _2c as "colorDeltaRed", _2d as "colorDeltaRedBg", _2e as "colorDetailsFieldText", _2f as "colorDetailsIcon", _30 as "colorDetailsTagBg", _31 as "colorMint", _32 as "colorMintGradient", _33 as "colorMintLight", _34 as "colorPrimary", _35 as "colorPrimaryHover", _36 as "colorPrimaryLightened", _37 as "colorTableHeadBg", _38 as "colorTableHeadBgHover", _39 as "colorTableHeadSubtitle", _3a as "colorTableRowBorder", _3b as "colorTableTextBg", _3c as "colorTableTotalRowBg", _3d as "colorTextBase", _3e as "colorTextDisabled", _3f as "colorTextExtraLight", _40 as "colorTextLight", _41 as "colorTextLighter", _42 as "colorTextMainHeading", _43 as "colorTextMuted", _44 as "colorTextPrimary", _45 as "contentHorizPadding", _46 as "dangerColor", _47 as "dashboardPdfContentWidth", _48 as "errorBackcolor", _49 as "errorColor", _4a as "filterPanelPadding", _4b as "filtersDefaultHeight", _4c as "filtersTallHeight", _4d as "fontSizeLarge", _4e as "fontSizeMain", _4f as "fontSizeMedium", _50 as "fontSizePlus", _51 as "fontSizeSmaller", _52 as "fontSizeSmallest", _53 as "fontSizeXLarge", _54 as "fontSizeXxLarge", _55 as "fontWeightBold", _56 as "fontWeightExtraLight", _57 as "fontWeightLight", _58 as "fontWeightMediumBold", _59 as "fontWeightNormal", _5a as "fontWeightSemiBold", _5b as "ghostWhite", _5c as "grayBackgroundColor", _5d as "headerHeight", _5e as "heading-1", _5f as "heading-2", _60 as "heading-3", _61 as "heading-4", _62 as "heading-5", _63 as "iconHorizontalMargin", _64 as "linkColor", _65 as "linkColorMuted", _66 as "page-heading", _67 as "popoverHeaderColor", _68 as "popoverMaskColor", _69 as "rowPadding", _6a as "ruleInnerGutters", _6b as "ruleSideGutters", _6c as "sideMenuIconColor", _6d as "sideMenuIconSelectedColor", _6e as "sideMenuItemColor", _6f as "sideMenuScrollbarThumbColor", _70 as "sideMenuSubmenuItemColor", _71 as "sidebarCollapsedWidth", _72 as "sidebarWidth", _73 as "successBackcolor", _74 as "successColor", _75 as "tableHeaderVerticalPadding", _76 as "tableHorizPadding", _77 as "warningBackcolor", _78 as "warningColor", _79 as "whiteColor", _7a as "whiteDividerColor" }
